export const signOptions = [
    // Original 100
    "", "🔹", "🔸", "⚜️", "✅", "❌", "🔴", "🟢", "🔵", "🟡",
    "⚪️", "⚫️", "⭐️", "✨", "🔥", "💎", "💍", "🏆", "🥇", "💯",
    "🇦🇪", "🇺🇸", "🇪🇺", "🇬🇧", "🇨🇳", "🇯🇵", "🇨🇭", "🇨🇦", "🇦🇺", "🇹🇷",
    "❤️", "💔", "👍", "👎", "👆", "👇", "👈", "👉", "📈", "📉",
    "💰", "💵", "💶", "💷", "💴", "🪙", "💳", "🏦", "📊", "⚖️",
    "🚗", "✈️", "🚀", "⚓️", "🏠", "🏢", "🏭", "🏰", "🌍", "🗺️",
    "☀️", "🌙", "☁️", "⚡️", "❄️", "💧", "🌊", "🔔", "🔑", "💡",
    "➡️", "⬅️", "⬆️", "⬇️", "🔄", "⏳", "⏰", "⌛️", "📡", "🔋",
    "📱", "💻", "🖥️", "⚙️", "🔗", "🛡️", "⚠️", "ℹ️", "❓", "❕",
    "📝", "📌", "📍", "📚", "🔖", "🎉", "🎁", "✉️", "📞", "👤",

    // New 100
    "➡️", "⬅️", "⬆️", "⬇️", "↔️", "↕️", "↖️", "↗️", "↘️", "↙️",
    "➕", "➖", "➗", "✖️", "💲", "©️", "®️", "™️", "🔚", "🔙",
    "🔛", "🔜", "🔝", "✔️", "☑️", "🔘", "🔗", "💥", "💫", "💦",
    "💨", "💬", "👁️", "🧠", "👋", "🙏", "💪", "👨‍💻", "👩‍🔬", "🧑‍🚀",
    "😀", "😂", "😊", "😍", "🤔", "🤫", "🤯", "🥳", "😭", "😡",
    "🐶", "🐱", "🐭", "🦊", "🐻", "🐼", "🐨", "🐯", "🦁", "🐵",
    "🐔", "🐧", "🐦", "🦋", "🐛", "🐜", "🐝", "🐞", "🐢", "🐍",
    "🍎", "🍊", "🍇", "🍓", "🍒", "🍑", "🍍", "🥝", "🥑", "🍔",
    "🍕", "🍟", "🍣", "🍦", "🍩", "🎂", "☕️", "🍵", "🍺", "🍷",
    "⚽️", "🏀", "🏈", "⚾️", "🎾", "🏐", "🎱", "⛳️", "🎿", "🎯"
];